import { Modal } from "@/components/modal";
import { Loading } from "@/features/request/feedback-tool/feedbackTool/components/Loading";

import Slack from "../../settings/icons/slack.png";

export function ModalSlack() {
  return (
    <Modal isOpen onOpenChange={() => {}}>
      <div className="flex items-center flex-col p-10">
        <img alt="Add to Slack" className="h-20" src={Slack} />
        <p className="text-text-quaternary font-bold mt-10 mb-5">
          Just a moment while we connect to Slack!
        </p>
        <Loading className="h-10" />
      </div>
    </Modal>
  );
}
